import React, {useEffect} from 'react';
import {
    useTable,
    useSortBy,
    usePagination,
} from 'react-table';
import {Table, Row, Col, Input, CustomInput} from 'reactstrap';
import Aux from '../../../hoc/Auxiliary';
import { useTranslation } from "react-i18next";

const TableContainer = ({columns, data, onSort, initialStateField, initialStateDirection}) => {
    const { t } = useTranslation();

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        prepareRow,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        setSortBy,
        rows,
        state: {pageIndex, pageSize, sortBy},
    } = useTable(
        {
            columns,
            data,
            rows,
            initialState: {pageIndex: 0, pageSize: 10, sortBy: [{id: initialStateField, desc: (initialStateDirection==='DESC')}]},
            disableSortRemove: true
        },
        useSortBy,
        usePagination
    );

    const generateSortingIndicator = (column) => {
        return column.isSorted ? (column.isSortedDesc ? <i className="fa fa-angle-down"></i> :
            <i className="fa fa-angle-up"></i>) : '';
    };

    const onChangeInSelect = (event) => {
        setPageSize(Number(event.target.value));
    };

    const onChangeInInput = (event) => {
        const page = event.target.value ? Number(event.target.value) - 1 : 0;
        gotoPage(page);
    };

    useEffect(() => {
        onSort(sortBy);
    }, [sortBy]);

    useEffect(() => {
        setSortBy( [{ id: initialStateField, desc: initialStateDirection==='DESC'}])
    }, [initialStateField, initialStateDirection]);

    return (
        <Aux>
            <div className="table-wrapper">
                <Table hover {...getTableProps()} className="datatable datatable--communications">
                    <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th {...column.getHeaderProps()}>
                                    <div {...column.getSortByToggleProps({title: t(`docs.togglesortby`)+' '+column.render("Header")})}>
                                        {column.render('Header')}
                                        {generateSortingIndicator(column)}
                                    </div>
                                    { /*<Filter column={column} /> */}
                                </th>
                            ))}
                        </tr>
                    ))}
                    </thead>

                    <tbody {...getTableBodyProps()}>
                    {page.map((row) => {
                        prepareRow(row);
                        return (
                            <Aux key={row.getRowProps().key}>
                                <tr>
                                    {row.cells.map((cell) => {
                                        return (
                                            <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                                        );
                                    })}
                                </tr>
                            </Aux>
                        );
                    })}
                    </tbody>
                </Table>
            </div>
            <div className="datatable__actions">
                <div className="datatable__actions__extras">
                    <Row className="flex--align-center">
                        <Col xs={6}>Page{' '} <strong>{pageIndex + 1} {t(`docs.pagination.of`)} {pageOptions.length === 0 ? pageOptions.length+1 : pageOptions.length}</strong></Col>
                        <Col xs={6} className="a-right">
                            <CustomInput
                                type="select"
                                value={pageSize}
                                id="row-range-select"
                                onChange={onChangeInSelect}
                            >

                                {[10, 20, 30, 40, 50].map((pageSize) => (
                                    <option key={pageSize} value={pageSize}>
                                        {t('misc.sorter.show')} {pageSize}
                                    </option>
                                ))}
                            </CustomInput>

                        </Col>
                    </Row>
                </div>
                <div className="datatable__actions__base flex flex--justify-center">
                    <button className="btn btn--table" onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
                        <i className="fas fa-angle-double-left"></i>
                    </button>
                    <button className="btn btn--table" onClick={previousPage} disabled={!canPreviousPage}>
                        <i className="fas fa-angle-left"></i>
                    </button>
                    <div>
                        <Input
                            type='number'
                            className='input-current-page'
                            min={1}
                            style={{width: 70}}
                            max={pageOptions.length}
                            value={pageIndex + 1}
                            onChange={onChangeInInput}
                        />

                    </div>
                    <button className="btn btn--table" onClick={nextPage} disabled={!canNextPage}>
                        <i className="fas fa-angle-right"></i>
                    </button>
                    <button className="btn btn--table" onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
                        <i className="fas fa-angle-double-right"></i>
                    </button>
                </div>
            </div>
        </Aux>
    );
};

export default TableContainer;
